import { memo } from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { Box, Text, Group } from '@mantine/core';
import { IconRouteAltRight } from '@tabler/icons-react';

function DecisionPointNode({ data, selected }: NodeProps) {
  return (
    <Box
      style={{
        background: 'white',
        border: `2px solid ${selected ? '#14b8a6' : '#e5e7eb'}`,
        borderRadius: '8px',
        padding: '10px 14px',
        minWidth: '180px',
        boxShadow: selected ? '0 4px 12px rgba(20, 184, 166, 0.3)' : '0 2px 8px rgba(0, 0, 0, 0.1)',
      }}
    >
      <Handle type="target" position={Position.Top} />
      <Group gap="xs" wrap="nowrap">
        <Box
          style={{
            background: '#14b8a6',
            borderRadius: '6px',
            padding: '5px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <IconRouteAltRight size={16} color="white" />
        </Box>
        <Box style={{ flex: 1 }}>
          <Text size="xs" c="dimmed" fw={500}>
            DECISION
          </Text>
          <Text size="sm" fw={600} lineClamp={1}>
            {data.title || 'Decision Point'}
          </Text>
        </Box>
      </Group>
      <Handle type="source" position={Position.Bottom} />
    </Box>
  );
}

export default memo(DecisionPointNode);
